export default __webpack_public_path__ + "static/media/(7).2e2f3246.jpeg";